export const ALERTA_AS_LABELS = {
  titulo: 'Campos obrigatórios para o Acordo Seguro',
  mensagem: 'Os seguintes campos estão em branco e são obrigatórios para o Acordo Seguro. Deseja continuar sem salvar no Acordo Seguro?',
  cancelar: 'Cancelar',
  continuar: 'Continuar',
};
